import fetch from "auth/FetchInterceptor";

const settingsService = {};
const apiRoute = "/AdminSettings";

settingsService.getSettings = async function (
  query = "",
  showErrorNotification = true
) {
  try {
    const res = await fetch({
      url: `${apiRoute}/public/get/all${query}`,
      method: "get",
      showErrorNotification: showErrorNotification,
    });
    return res;
  } catch (err) {
    console.log(err.response?.data || err.message, "API Error - getAll");
    console.log(err, "show-err");
  }
};

settingsService.getSettingsPublic = async function (
  query = "",
  showErrorNotification = true
) {
  try {
    const res = await fetch({
      url: `${apiRoute}/public/get/all${query}`,
      method: "get",
      showErrorNotification: showErrorNotification,
    });
    return res;
  } catch (err) {
    console.log(err.response?.data || err.message, "API Error - getAll");
    console.log(err, "show-err");
  }
};

settingsService.edit = async function (id, data) {
  try {
    const res = await fetch({
      url: `${apiRoute}/admin/update/${id}`,
      method: "patch",
      data: data,
    });
    return res;
  } catch (err) {
    console.log(err.response?.data || err.message, "API Error - edit");
    console.log(err, "show-err");
  }
};

export default settingsService;
